import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const loginInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          if (event.status === 401 || event.status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            router.navigate(['/login']).then();
          }
        }
      },
      error: (err) => {
        if (err.status === 401 || err.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          router.navigate(['/login']).then();
        }
      }
    })
  );
};
